import React from "react";
import {
    MDBRow,
    MDBCol,
    MDBBtn,
    MDBContainer,
    MDBSelect, MDBTableHead, MDBTable, MDBTableBody, MDBIcon, MDBSpinner
} from "mdbreact";
import firebase from "../../../firebase";

class EditCompany extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            companyFax: '',
            companyTel: '',
            companyCorpNo: '',
            companyAddress: '',
            companyName: '',
            companyKanaName: '',
            companyZip: '',
            loading: false,
            companyData: {},
        }
    }

    componentDidMount() {
        this.setupCompanyData();
    }

    setupCompanyData = async () => {
        this.setState({loading: true});
        let companyRef =  this.props.db.collection('company').doc(this.props.id);
        let getDoc = companyRef.get()
            .then(doc => {
                if (!doc.exists) {
                    console.log('No such company document!')
                } else {
                        let data = {};
                        data = doc.data();
                        data.id = doc.id;
                        this.setState({
                            companyFax: data['FAX'],
                            companyTel: data['TEL'],
                            companyCorpNo: data['法人番号'],
                            companyAddress: data['address'],
                            companyName: data['name'],
                            companyKanaName: data['kana'],
                            companyZip: data['zipcode'],
                            id : data.id,
                            companyData: data,
                        })
                    this.setState({loading: false})
                }
            })
            .catch(err => {
                this.setState({loading: false});
                console.log('Error getting company document', err)
            })
    }
    onSubmit = () => {
        let companyRef = this.props.db.collection('company').doc(this.props.id);
        companyRef.update({
            FAX: this.state.companyFax,
            TEL: this.state.companyTel,
            address: this.state.companyAddress,
            kana: this.state.companyKanaName,
            name:this.state.companyName,
            zipcode: this.state.companyZip,
            '法人番号': this.state.companyCorpNo,
            updated: firebase.firestore.Timestamp.fromDate(new Date()),
        });
        console.log('companyRef',companyRef.id);
        this.props.cProps.history.push('/company/preview/' + this.props.id);
    }
    render() {
        let isDisabled = true;
        if(this.state.companyFax !== this.state.companyData['FAX'] || this.state.companyTel !== this.state.companyData['TEL'] || this.state.companyCorpNo !== this.state.companyData['法人番号']
            || this.state.companyAddress !== this.state.companyData['address'] || this.state.companyName !== this.state.companyData['name']
            || this.state.companyKanaName !== this.state.companyData['kana'] || this.state.companyZip !== this.state.companyData['zipcode']) {
            isDisabled = false;
        }
        return (
            <>
                {
                    this.props.user && this.props.user.admin &&
                    <MDBContainer>
                        {this.state.loading && <div className="d-flex justify-content-center mt-5"><MDBSpinner/></div>}
                        <MDBRow>
                            <MDBCol md="12" className="mb-3">
                                <h2>{this.state.companyName}</h2>
                                <div style={{
                                    height: 30, justifyContent: 'flex-start', padding: 5, paddingLeft: 10,
                                    alignItems: "center", backgroundColor: '#2E75B6', color: 'white'
                                }}>企業情報
                                </div>

                                <div style={{
                                    border: '1px solid #B9B9B9',
                                    padding: 10,
                                    marginBottom: 20,
                                    marginTop: 10
                                }}>
                                    <div className="form-check">
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <label htmlFor="companyName" className="grey-text">
                                                会社名
                                            </label>
                                        </div>
                                        <input
                                            type="text"
                                            id="companyName"
                                            className="form-control"
                                            name="companyName"
                                            onChange={(e) => {
                                                this.setState({
                                                    companyName: e.currentTarget.value
                                                });
                                            }}
                                            value={this.state.companyName}
                                        />
                                        <br/>
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <label htmlFor="companyKanaName" className="grey-text">
                                                会社名かな
                                            </label>
                                        </div>
                                        <input
                                            type="text"
                                            id="companyKanaName"
                                            className="form-control"
                                            name="companyKanaName"
                                            onChange={(e) => {
                                                this.setState({
                                                    companyKanaName: e.currentTarget.value
                                                });
                                            }}
                                            value={this.state.companyKanaName}
                                        />
                                        <br/>
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <label htmlFor="companyZip" className="grey-text">
                                                郵便番号
                                            </label>
                                        </div>
                                        <input
                                            type="text"
                                            id="companyZip"
                                            className="form-control"
                                            name="companyZip"
                                            placeholder={'例）123-4567（ハイフン付き7桁）'}
                                            onChange={(e) => {
                                                this.setState({
                                                    companyZip: e.currentTarget.value
                                                });
                                            }}
                                            value={this.state.companyZip}
                                        />
                                        <br/>
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <label htmlFor="companyAddress" className="grey-text">
                                                住所
                                            </label>
                                        </div>
                                        <input
                                            type="text"
                                            id="companyAddress"
                                            className="form-control"
                                            name="companyAddress"
                                            onChange={(e) => {
                                                this.setState({
                                                    companyAddress: e.currentTarget.value
                                                });
                                            }}
                                            value={this.state.companyAddress}
                                        />
                                        <br/>
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <label htmlFor="companyTel" className="grey-text">
                                                TEL
                                            </label>
                                        </div>
                                        <input
                                            type="text"
                                            id="companyTel"
                                            className="form-control"
                                            name="companyTel"
                                            onChange={(e) => {
                                                this.setState({
                                                    companyTel: e.currentTarget.value
                                                });
                                            }}
                                            value={this.state.companyTel}
                                        />
                                        <br/>
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <label htmlFor="companyFax" className="grey-text">
                                                FAX
                                            </label>
                                        </div>
                                        <input
                                            type="text"
                                            id="companyFax"
                                            className="form-control"
                                            name="companyFax"
                                            onChange={(e) => {
                                                this.setState({
                                                    companyFax: e.currentTarget.value
                                                });
                                            }}
                                            value={this.state.companyFax}
                                        />
                                        <br/>
                                        <div style={{display: 'flex', alignItems: 'center'}}>
                                            <label htmlFor="companyCorpNo" className="grey-text">
                                                法人番号
                                            </label>
                                        </div>
                                        <input
                                            type="text"
                                            id="companyCorpNo"
                                            className="form-control"
                                            name="companyCorpNo"
                                            placeholder={'13桁（ハイフン不要）'}
                                            onChange={(e) => {
                                                this.setState({
                                                    companyCorpNo: e.currentTarget.value
                                                });
                                            }}
                                            value={this.state.companyCorpNo}
                                        />
                                    </div>

                                </div>

                            </MDBCol>
                        </MDBRow>
                        <div style={{flexDirection: 'row', justifyContent: 'center', display: 'flex'}}>
                            <MDBBtn color="secondary"
                                    onClick={() => this.props.cProps.history.push('/company/preview/' + this.state.id)}>キャンセル</MDBBtn>
                            <MDBBtn
                                color="default"
                                type="submit"
                                disabled={isDisabled}
                                onClick={this.onSubmit}
                            >登録</MDBBtn>
                        </div>
                    </MDBContainer>
                }
            </>
        )
    }
}

export default EditCompany;
